/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resources_Scanupload_Name1Inputs */

const en_resources_scanupload_name1 = /** @type {(inputs: Resources_Scanupload_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan Uploads`)
};

const fr_resources_scanupload_name1 = /** @type {(inputs: Resources_Scanupload_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement des scans`)
};

const es_resources_scanupload_name1 = /** @type {(inputs: Resources_Scanupload_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carga de escaneos`)
};

const de_resources_scanupload_name1 = /** @type {(inputs: Resources_Scanupload_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan-Uploads`)
};

const nl_resources_scanupload_name1 = /** @type {(inputs: Resources_Scanupload_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan-uploads`)
};

/**
* | output |
* | --- |
* | "Scan Uploads" |
*
* @param {Resources_Scanupload_Name1Inputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "de" | "nl" }} options
* @returns {LocalizedString}
*/
const resources_scanupload_name1 = /** @type {((inputs?: Resources_Scanupload_Name1Inputs, options?: { locale?: "en" | "fr" | "es" | "de" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resources_Scanupload_Name1Inputs, { locale?: "en" | "fr" | "es" | "de" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_resources_scanupload_name1(inputs)
	if (locale === "fr") return fr_resources_scanupload_name1(inputs)
	if (locale === "es") return es_resources_scanupload_name1(inputs)
	if (locale === "de") return de_resources_scanupload_name1(inputs)
	return nl_resources_scanupload_name1(inputs)
});
export { resources_scanupload_name1 as "resources.scanUpload.name" }